import {FC, useState, createContext, useContext, useMemo} from 'react'
import { useMutation } from 'react-query'
import { boolean } from 'yup'
import {
  ID,
  calculatedGroupingIsDisabled,
  calculateIsAllDataSelected,
  groupingOnSelect,
  initialListView,
  ListViewContextProps,
  groupingOnSelectAll,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import {useQueryResponse, useQueryResponseData} from './QueryResponseProvider'
import { LinksData } from './_models'
import { Embedding } from '../../../training/training-list/core/_models'

const ListViewContext = createContext<ListViewContextProps>(initialListView)

const ListViewProvider: FC<WithChildren> = ({children}) => {
  const [selected, setSelected] = useState<Array<ID>>(initialListView.selected)
  const [itemIdForUpdate, setItemIdForUpdate] = useState<ID>(initialListView.itemIdForUpdate)
  const {isLoading} = useQueryResponse()
  const data = useQueryResponseData()
  const disabled = useMemo(() => calculatedGroupingIsDisabled(isLoading, data), [isLoading, data])
  const isAllSelected = useMemo(() => calculateIsAllDataSelected(data, selected), [data, selected])
  const [statusModal, setStatusModal]  = useState<boolean>(false)
  const [modalAction, setModalAction]  = useState<boolean>(false)
  const [user, setUser]  = useState<Embedding>({})
  const [passwordUpdateCheck, setpasswordUpdateCheck] = useState<boolean>(false)


  return (
    <ListViewContext.Provider
      value={{
        selected,
        itemIdForUpdate,
        setItemIdForUpdate,
        disabled,
        isAllSelected,
        onSelect: (id: ID) => {
          groupingOnSelect(id, selected, setSelected)
        },
        onSelectAll: () => {
          groupingOnSelectAll(isAllSelected, setSelected, data)
        },
        clearSelected: () => {
          setSelected([])
        },
        statusModal,
        setStatusModal: (value,actionValue,user) => {
          setModalAction(actionValue)
          setUser(user)
          setStatusModal(value);
        },
        modalAction,
        user,
        passwordUpdateCheck,
        setpasswordUpdateCheck
      }}
    >
      {children}
    </ListViewContext.Provider>
  )


  
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}
